import React from 'react';
import { Link } from 'react-router-dom';

export default class CourseCatalog extends React.Component
{
    constructor(props)
    {
        super(props);
        this.selectCourse = this.selectCourse.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.getCourseCategories = this.getCourseCategories.bind(this);
        this.state = {
            loaded: false,
            error: "",
            courses: [],
            filteredCourses: [],
            categories: [],
            searchTerm: "",
            category: 0
        }
    }
    componentDidMount()
    {
        this.getCourses(this.getCourseCategories);
    }
    getCourses(callback)
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourses",
            method: "post",
            body: JSON.stringify({categoryID: this.state.category}),
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, courses: result.courses, searchTerm: "", filteredCourses: result.courses}, 
                            () => callback ? callback() : null) :
                    this.setState({loaded: true, error: result.message})
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load courses.  Please try again later."})
            }
        })
    }
    getCourseCategories()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourseCategories",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, categories: result.categories}) :
                    this.setState({loaded: true, error: result.message})
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load course categories.  Please try again later."})
            }
        })
    }
    searchChanged(e)
    {
        let courses = this.state.courses;
        courses = courses.filter((c) => c.courseName.toLowerCase().match(e.target.value.toLowerCase()));
        this.setState({filteredCourses: courses, searchTerm: e.target.value});
    }
    selectCourse(course)
    {
        this.setState({selectedCourse: course})
    }
    render()
    {
        const flattenedcats = []
        const flatten = (categories, level) => {
            categories.forEach(c => {
                let frontload = ""
                for (let l = 0; l < level; l++)
                {
                    frontload += " -- ";
                }
                flattenedcats.push({
                    id: c.categoryID, 
                    name: frontload + c.name
                });
                flatten(c.subcategories, level+1)
            })
        }
        flatten(this.state.categories, 0)
        const cartCoursesIDs = this.props.cart.cartCourses.map((c) => c.courseID);
        const courselist = this.state.filteredCourses.map((c) => 
            <div className={c.owned ? "lmscourse lmscourseowned" : 
                cartCoursesIDs.indexOf(c.courseID) === -1 ? "lmscourse" : 
                "lmscourse lmscartcourse"} key={c.courseID}>
                <div className="lmscourseinner">
                    <div className="lmscoursesummary" style={{backgroundImage: "url('/courses/" + c.courseID + "/Thumb.jpg')" }}>
                        <div className="lmscoursesummaryshroud">
                            <strong>{c.courseName}</strong>
                        </div>
                    </div>
                    <div className={c.owned ? "lmscoursefooter lmscourseownedfooter" :
                        cartCoursesIDs.indexOf(c.courseID) === -1 ? "lmscoursefooter" : 
                            "lmscourseincart lmscoursefooter"}>
                        <Link to={"/Courses/" + c.courseID} className={c.owned ? "lmsbutton lmsbuttongreen" : cartCoursesIDs.indexOf(c.courseID) === -1 ? 
                            "lmsbutton" : "lmsbutton lmsbuttonred" }>Details</Link>
                        {c.owned ? null :
                            cartCoursesIDs.indexOf(c.courseID) === -1 ? (
                                <Link to="/" className="lmsbutton" onClick={(e) => this.props.addToCart(e, c.courseID)}>Add to Cart</Link>
                            ) : (
                                <Link to="/" className="lmsbutton lmsbuttonred" onClick={(e) => this.props.removeFromCart(e, c.courseID)}>Remove from Cart</Link>
                            )
                        }
                    </div>
                </div>
            </div>
        )
        return (
            <div className="lmsdisplayarea">
                <h3>Course Catalog</h3>
                <select className="lmsforminput" style={{marginBottom: "12px"}} 
                    onChange={(e) => this.setState({category: e.target.value, searchTerm: ""}, () => this.getCourses())}
                    value={this.state.category}>
                    <option value="0">-- Select a Category --</option>
                    {flattenedcats.map(f => 
                        <option key={f.id} value={f.id}>{f.name}</option>  
                    )}
                </select>
                <div style={{display: "inline", marginLeft: "15px"}}>
                    Search: <input className="lmsforminput" type="text" value={this.state.searchTerm} 
                        onChange={e => this.searchChanged(e)} />
                </div>
                {this.state.loaded ? 
                    this.state.filteredCourses.length > 0 ? (
                        <div className="courseList">
                            {courselist}
                            <div className="lmslibraryfooter">
                                <Link to="/Cart" className="lmsbutton">Checkout</Link>
                            </div>
                        </div>
                    ) : (
                        <p>
                            <i>No courses found.</i>
                        </p>
                    ) 
                : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/catalog/coursecatalog.js